function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Special_Events #CE0058");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.811357051 0.963486498 349.817047 0.963486498 349.817047 349.969176 0.811357051 349.969176"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Special_Events-#CE0058",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Special_Events"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.314709,344.466331 C268.657558,344.466331 344.314202,268.799548 344.314202,175.472922 C344.314202,82.1331151 268.657558,6.46633144 175.314709,6.46633144 C81.9718597,6.46633144 6.31420199,82.1331151 6.31420199,175.472922 C6.31420199,268.799548 81.9718597,344.466331 175.314709,344.466331",
  id: "Fill-1",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.238179,104.881536 C175.843774,104.881536 165.372682,94.3832151 165.372682,82.016039 C165.372682,68.5919779 175.843774,58.1563899 188.238179,58.1563899 C201.626735,58.1563899 212.097828,68.5919779 212.097828,82.016039 C212.097828,94.3832151 201.626735,104.881536 188.238179,104.881536 L188.238179,104.881536 Z M193.208939,288.799665 C187.184882,291.496486 178.282652,292.776273 170.343442,292.776273 C142.373567,292.776273 126.494748,279.071095 132.565664,247.045279 L156.425313,134.706098 L198.179699,134.706098 L175.314202,241.080367 C173.099075,253.866753 175.13142,259.611355 188.238179,259.969255 C194.378866,259.611355 199.357014,258.643298 203.150459,256.986799 L193.208939,288.799665 Z M175.314202,5.46633144 C81.5419565,5.46633144 5.31420199,81.7440114 5.31420199,175.466331 C5.31420199,269.209527 81.5419565,345.466331 175.314202,345.466331 C269.054638,345.466331 345.314202,269.209527 345.314202,175.466331 C345.314202,81.7440114 269.054638,5.46633144 175.314202,5.46633144 L175.314202,5.46633144 Z",
  id: "Fill-3",
  fill: "#CE0058",
  mask: "url(#mask-2)"
})));

const SvgIconsSpecialEvents = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "350px",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsSpecialEvents, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icons-special-events.80bb3a0c.svg";
export { ForwardRef as ReactComponent };